// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.active-filter-chip {
  display: inline-flex;
  align-items: center;
  background-color: #e0eaff;
  color: #004d99;
  padding: 5px 10px;
  border-radius: 20px;
  margin-right: 8px;
  margin-bottom: 8px;
  font-size: 9px;
  /* max-width: 15%;
  width: auto; */
  max-height: 20px;
  overflow: auto;
}
.active-filter-chip {
  transition: transform 0.2s, background-color 0.2s, color 0.2s, box-shadow 0.2s;
}

.active-filter-chip .remove-filter {
  margin-left: 8px;
  cursor: pointer;
  font-weight: bold;
  color: #004d99;
}
.tooltip-content-active-filter-chip {
  visibility: hidden;
  width: auto;
  background-color: #555555b0;
  color: var(--white-color);
  text-align: left;
  /* padding: 10px; */
  border-radius: 5px;
  position: absolute;
  z-index: 1;
  top: 100%;
  /* left: 50%; */
  transform: translateX(-50%);
  opacity:0;
  transition: opacity 0.3s;
  font-size: var(--font-size-small);


  text-align: center;
  border-radius: 6px;
  /* padding: 5px 10px; */
  position: absolute;
  z-index: 1;
  top: 100%; /* Posicionamiento debajo del chip */
  left: 50%;
  transform: translateX(-50%);
  margin-top: 5px; /* Pequeño espacio entre el chip y el tooltip */
  white-space: nowrap; /* Evita que el texto del tooltip se envuelva */
  transition: opacity 0.3s;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
   top: calc(100% + 5px); /* Posiciona el tooltip justo debajo del chip */
  left: 20%; /* Centra el tooltip horizontalmente */
  transform: translateX(-50%); 
}
.tooltip-container-active-filter-chip:hover .tooltip-content-active-filter-chip {
  visibility: visible;
  opacity: 1;
}
.tooltip-content-active-filter-chip::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 10px; /* <-- Ajusta la posición de la flecha para que se alinee con el inicio del texto */
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #007bff transparent;
}


/* Estilo del contenedor del chip */
.active-filter-chip {
  display: inline-flex;
  align-items: center;
  background-color: #e0eaff;
  color: #004d99;
  padding: 5px 10px;
  border-radius: 20px;
  margin-right: 8px;
  margin-bottom: 8px;
  font-size: 14px;
  position: relative;
  transition: all 0.2s ease-in-out;
  overflow: unset;
  font-size: 8px;
  /* max-width: 15%;
  width: auto; */
  max-height: 20px;
  overflow: unset;
}

/* Estilo del tooltip */
.chip-tooltip {
  visibility: hidden; /* Oculto por defecto */
  opacity: 0;
  background-color: #007bff; /* Color azul */
  color: #fff;
  text-align: left;
  border-radius: 6px;
  padding: 5px 10px;
  /* Posicionamiento del tooltip */
  position: absolute;
  z-index: 1;
  top: 100%; /* Se posiciona justo debajo del chip */
  left: 0; /* Alinea el borde izquierdo del tooltip con el del chip */
  transform: none;
  margin-top: 5px; /* Espacio entre el chip y el tooltip */
  white-space: nowrap; /* Evita que el texto se parta en varias líneas */
  /* Animación para que el tooltip aparezca suavemente */
  transition: opacity 0.3s, visibility 0s;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

/* Flecha del tooltip */
.chip-tooltip::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 10px; /* Posición de la flecha */
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #007bff transparent; /* Color de la flecha */
}

/* Selector que hace visible el tooltip al pasar el cursor sobre el chip */
.active-filter-chip:hover .chip-tooltip {
  visibility: visible;
  opacity: 1;
}

`, "",{"version":3,"sources":["webpack://./src/components/monitor-components/Events/styles/ActiveFilterChips.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd;gBACc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,8EAA8E;AAChF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,eAAe;EACf,2BAA2B;EAC3B,SAAS;EACT,wBAAwB;EACxB,iCAAiC;;;EAGjC,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,SAAS,EAAE,oCAAoC;EAC/C,SAAS;EACT,2BAA2B;EAC3B,eAAe,EAAE,+CAA+C;EAChE,mBAAmB,EAAE,+CAA+C;EACpE,wBAAwB;EACxB,qCAAqC;GACpC,qBAAqB,EAAE,+CAA+C;EACvE,SAAS,EAAE,sCAAsC;EACjD,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU,EAAE,mFAAmF;EAC/F,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,yDAAyD;AAC3D;;;AAGA,mCAAmC;AACnC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd;gBACc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB,EAAE,uBAAuB;EAC3C,UAAU;EACV,yBAAyB,EAAE,eAAe;EAC1C,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;EACV,SAAS,EAAE,uCAAuC;EAClD,OAAO,EAAE,0DAA0D;EACnE,eAAe;EACf,eAAe,EAAE,uCAAuC;EACxD,mBAAmB,EAAE,iDAAiD;EACtE,sDAAsD;EACtD,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU,EAAE,0BAA0B;EACtC,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,yDAAyD,EAAE,uBAAuB;AACpF;;AAEA,0EAA0E;AAC1E;EACE,mBAAmB;EACnB,UAAU;AACZ","sourcesContent":[".active-filter-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  background-color: #e0eaff;\r\n  color: #004d99;\r\n  padding: 5px 10px;\r\n  border-radius: 20px;\r\n  margin-right: 8px;\r\n  margin-bottom: 8px;\r\n  font-size: 9px;\r\n  /* max-width: 15%;\r\n  width: auto; */\r\n  max-height: 20px;\r\n  overflow: auto;\r\n}\r\n.active-filter-chip {\r\n  transition: transform 0.2s, background-color 0.2s, color 0.2s, box-shadow 0.2s;\r\n}\r\n\r\n.active-filter-chip .remove-filter {\r\n  margin-left: 8px;\r\n  cursor: pointer;\r\n  font-weight: bold;\r\n  color: #004d99;\r\n}\r\n.tooltip-content-active-filter-chip {\r\n  visibility: hidden;\r\n  width: auto;\r\n  background-color: #555555b0;\r\n  color: var(--white-color);\r\n  text-align: left;\r\n  /* padding: 10px; */\r\n  border-radius: 5px;\r\n  position: absolute;\r\n  z-index: 1;\r\n  top: 100%;\r\n  /* left: 50%; */\r\n  transform: translateX(-50%);\r\n  opacity:0;\r\n  transition: opacity 0.3s;\r\n  font-size: var(--font-size-small);\r\n\r\n\r\n  text-align: center;\r\n  border-radius: 6px;\r\n  /* padding: 5px 10px; */\r\n  position: absolute;\r\n  z-index: 1;\r\n  top: 100%; /* Posicionamiento debajo del chip */\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  margin-top: 5px; /* Pequeño espacio entre el chip y el tooltip */\r\n  white-space: nowrap; /* Evita que el texto del tooltip se envuelva */\r\n  transition: opacity 0.3s;\r\n  box-shadow: 0 2px 5px rgba(0,0,0,0.2);\r\n   top: calc(100% + 5px); /* Posiciona el tooltip justo debajo del chip */\r\n  left: 20%; /* Centra el tooltip horizontalmente */\r\n  transform: translateX(-50%); \r\n}\r\n.tooltip-container-active-filter-chip:hover .tooltip-content-active-filter-chip {\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n.tooltip-content-active-filter-chip::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  bottom: 100%;\r\n  left: 10px; /* <-- Ajusta la posición de la flecha para que se alinee con el inicio del texto */\r\n  margin-left: -5px;\r\n  border-width: 5px;\r\n  border-style: solid;\r\n  border-color: transparent transparent #007bff transparent;\r\n}\r\n\r\n\r\n/* Estilo del contenedor del chip */\r\n.active-filter-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  background-color: #e0eaff;\r\n  color: #004d99;\r\n  padding: 5px 10px;\r\n  border-radius: 20px;\r\n  margin-right: 8px;\r\n  margin-bottom: 8px;\r\n  font-size: 14px;\r\n  position: relative;\r\n  transition: all 0.2s ease-in-out;\r\n  overflow: unset;\r\n  font-size: 8px;\r\n  /* max-width: 15%;\r\n  width: auto; */\r\n  max-height: 20px;\r\n  overflow: unset;\r\n}\r\n\r\n/* Estilo del tooltip */\r\n.chip-tooltip {\r\n  visibility: hidden; /* Oculto por defecto */\r\n  opacity: 0;\r\n  background-color: #007bff; /* Color azul */\r\n  color: #fff;\r\n  text-align: left;\r\n  border-radius: 6px;\r\n  padding: 5px 10px;\r\n  /* Posicionamiento del tooltip */\r\n  position: absolute;\r\n  z-index: 1;\r\n  top: 100%; /* Se posiciona justo debajo del chip */\r\n  left: 0; /* Alinea el borde izquierdo del tooltip con el del chip */\r\n  transform: none;\r\n  margin-top: 5px; /* Espacio entre el chip y el tooltip */\r\n  white-space: nowrap; /* Evita que el texto se parta en varias líneas */\r\n  /* Animación para que el tooltip aparezca suavemente */\r\n  transition: opacity 0.3s, visibility 0s;\r\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n/* Flecha del tooltip */\r\n.chip-tooltip::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  bottom: 100%;\r\n  left: 10px; /* Posición de la flecha */\r\n  margin-left: -5px;\r\n  border-width: 5px;\r\n  border-style: solid;\r\n  border-color: transparent transparent #007bff transparent; /* Color de la flecha */\r\n}\r\n\r\n/* Selector que hace visible el tooltip al pasar el cursor sobre el chip */\r\n.active-filter-chip:hover .chip-tooltip {\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
